import { render, staticRenderFns } from "./PrinorTabs.vue?vue&type=template&id=40c68bcc&scoped=true&"
import script from "./PrinorTabs.vue?vue&type=script&lang=js&"
export * from "./PrinorTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c68bcc",
  null
  
)

export default component.exports